import { useState, useEffect } from "react"
import Layout from "../../Frames/Layout"
import { Stack, Alert, Button, IconButton, Typography } from "@mui/material"
import API from "../../../services/API"
import Loader from "../../Tools/Loader"
import { Link, Navigate, useParams } from "react-router-dom"
import { LoadingButton } from "@mui/lab"
import Pro from "../../Account/components/Pro"
import Location from "../../Account/components/Location"
import General from "../../Account/components/General"
import { ArrowBack } from "@mui/icons-material"
import UserContext from "../../../services/Context/UserContext"
import { useContext } from "react"
import Password from "../../Inputs/Password"
import Tester from "../../../services/Tester"
import ToastContext from "../../../services/Context/ToastContext"
import { txt } from "../../../services/translation"

export default function Form(){

    const {id} = useParams()

    const {user} = useContext(UserContext)

    const {setToast} = useContext(ToastContext)

    const [data, setData] = useState(null)

    const [status, setStatus] = useState('loading')

    const [errors, setErrors] = useState({})

    const statusIs = str => str === status
    const statusIn = arr => arr.includes(status)

    useEffect(() => {

        if(id !== 'new'){

            API.get(`/companies/me/users/${id}`)
                .then(r => {
                    setData(r.data)
                    setStatus('ready')
                })
                .catch(e => setStatus('error'))

        }else{

            setData({
                lastName: '',
                firstName: '',
                email: '',
                phone: '+33',
                password: '',
                address: user.address,
                zip: user.zip,
                city: user.city,
                country: user.country,
                siret: user.siret,
                category: user.category,
                origin: {id: 'entreprise'},
            })

            setStatus('ready')
        }


    }, [id, user])


    const handleSubmit = e => {
        e.preventDefault();
    
        if(!validate()) return false;
    
        setStatus('submit');
    
        (id !== 'new' ? API.put(`/companies/me/users/${id}`, data) : API.post(`/companies/me/users`, data))
            .then(r => {
                setStatus('redirect')
                setToast({severity: 'success', message: txt(`user${r.status === 201 ? 'Created' : 'Modified'}Success`), duration: 4000})
            })
            .catch(e => {
                if(e.response?.status === 409){
                    setErrors({...errors, email: txt('emailAlreadyUsed')})
                }
                setStatus('ready')
                setToast({severity: 'error', message: txt('errorOccurred'), duration: 4000})
            })
    }
    


    const validate = () => {
        let e = {};
    
        if(!Tester.testPhone(data.phone)) 
            e.phone = txt('invalidPhoneNumber');
    
        if(!Tester.testEmail(data.email)) 
            e.email = txt('invalidEmail');
    
        if(data.password && !Tester.testPassword(data.password)) 
            e.password = txt('invalidPasswordRequirements');
        
        setErrors(e);
    
        return Object.keys(e).length === 0;
    }
    


    if(statusIs('redirect')) return <Navigate to="/company" />


    return <Layout tab='company' menu='main'>

        {statusIn(['ready','submit']) && <form onSubmit={handleSubmit}>
    
            <Stack spacing={2} sx={{maxWidth: 600, margin: 'auto', mt: 3}}>

                <Stack direction='row' justifyContent='space-between' alignItems='center'>
                    <Typography variant='h1'>{id !== 'new' ? txt('updateAnAccount') : txt('createAnAccount')}</Typography>

                    <Link to="/company">
                        <IconButton>
                            <ArrowBack />
                        </IconButton>
                    </Link>
                </Stack>

                {id === 'new' &&
                    <Alert severity="info">{txt('userCompanyAffiliation')} <b>{user.company.name}</b>.</Alert>
                }
    
                <General
                    user={data}
                    onChange={value => setData(value)}
                    errors={errors}
                    show
                    edit
                    hidePhoneCountry
                />
    
                <Location
                    user={data}
                    onChange={value => setData(value)}
                    errors={errors}
                    show
                />
    
                <Pro
                    user={data}
                    onChange={value => setData(value)}
                    errors={errors}
                    show={['category','status']}
                />

                {id === 'new' &&
                    <Password 
                        value={data.password}
                        onChange={e => setData({...data, password: e.target.value})}
                        required
                        helperText={txt('passwordRequirements')}
                        error={errors.password}
                    />
                }
    
    
                <Stack direction='row' justifyContent='space-between' spacing={3}>

                    <Link to="/company">
                        <Button variant='outlined'>
                            {txt('cancel')}
                        </Button>
                    </Link>
    
                    <LoadingButton
                        variant='contained'
                        type='submit'
                        loading={statusIs('submit')}
                    >
                        {txt('save')}
                    </LoadingButton>
    
                </Stack>
    
            </Stack>
    
        </form>}

        {statusIs('loading') && <Loader />}

        {statusIs('error') && 
            <Alert severity='error'>Le contact n'a pas pu être chargé</Alert>
        }

    </Layout>
}